import * as React from 'react'
import { cn } from '#app/utils/misc.tsx'
import { Button, type ButtonProps } from './button.tsx'

export const StatusButton = React.forwardRef<
	HTMLButtonElement,
	ButtonProps & {
		status: 'pending' | 'success' | 'error' | 'idle'
		message?: string | null
	}
>(({ message, status, className, children, ...props }, ref) => {
	return (
		<Button ref={ref} className={cn('flex justify-center gap-4', className)} {...props}>
			<div>{children}</div>
			{message}
		</Button>
	)
})
StatusButton.displayName = 'Button'
